import type { ChildrenProps, ClassNameProps } from "../types";
import { cn } from "../utils";

/**
 * The row a set of `Stats` is laid out in.
 *
 * A grid rather than a wrapping flex line, because every figure has to occupy the same width in
 * every row: flex items share the width of the line they land on, so a first row of five and a
 * second row of two gave the second row's figures half the container each and nothing lined up.
 * `auto-fit` keeps the column count following the container, which is what a card in a resizable
 * panel needs.
 *
 * The child override earns its `!`: `Stats` sets `min-width: max-content` inline, which would let
 * a long figure push its track past the equal share and undo the alignment again — and only an
 * important declaration outranks an inline style. The inline `flex: 1` beside it needs no undoing,
 * since flex properties do not apply to a grid item.
 */
export function StatsContainer({ children, className }: ChildrenProps & ClassNameProps) {
	/** Render */
	return (
		<div
			className={cn(
				"grid grid-cols-[repeat(auto-fit,minmax(9rem,1fr))] gap-x-6 gap-y-6 [&>*]:min-w-0!",
				className,
			)}
		>
			{children}
		</div>
	);
}
